// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__6SGLO","header":"App_header__lAoxS","title":"App_title__Zo2p8","subtitle":"App_subtitle__Rp2H1"};